<template>
  <div>
    <span v-for="sensor in sensorList" :key="sensor.id">
      <el-tag type="info" v-if="sensor.code">
        {{ sensor.code }} -
        {{ sensor.two_name == '' ? sensor.name : sensor.two_name }}</el-tag
      >
      <el-tag type="info" v-else>{{ sensor }}</el-tag>
    </span>
  </div>
</template>
<script>
export default {
  name: 'sensor-list',
  props: {
    sensorList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
